import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

const MULTIPART_CONFIG = { headers: { "Content-Type": "multipart/form-data" } };

// ── Lawyers ──────────────────────────────────────────────────────────────────

export const getLawyersApi = (ownerId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_LAWYERS}?ownerId=${ownerId}`);

export const deleteLawyerApi = (lawyerId) =>
  apiClient.delete(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_LAWYERS}/${lawyerId}`);

export const acceptInvitationApi = (inviteeId, ownerId, isAccepted) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_LAWYERS}`, {
    inviteeId,
    ownerId,
    isAccepted,
  });

// ── Clients ───────────────────────────────────────────────────────────────────

export const getClientsApi = (ownerId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CLIENTS}?ownerId=${ownerId}`);

export const getClientsCountApi = (ownerId) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CLIENTS}/count?ownerId=${ownerId}`
  );

export const createClientApi = (clientData) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CLIENTS}`,
    clientData,
    { headers: { "Content-Type": "application/json" } }
  );

export const updateClientApi = (clientId, clientData) =>
  apiClient.put(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CLIENTS}/${clientId}`,
    clientData
  );

export const deleteClientApi = (clientId) =>
  apiClient.delete(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CLIENTS}/${clientId}`);

// ── Cases ─────────────────────────────────────────────────────────────────────

export const getCasesApi = (ownerId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/associate/${ownerId}`);

export const createCaseApi = (caseData) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}`,
    caseData,
    { headers: { "Content-Type": "application/json" } }
  );

export const updateCaseApi = (caseId, caseData) =>
  apiClient.put(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}`, caseData);

export const deleteCaseApi = (caseId) =>
  apiClient.delete(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}`);

// ── Case References ───────────────────────────────────────────────────────────

export const deleteCaseReferenceApi = (caseId, referenceCaseId) =>
  apiClient.delete(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/references`,
    { referenceCaseId }
  );

export const deleteStatuteReferenceApi = (caseId, referenceStatuteId) =>
  apiClient.delete(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/statute-references`,
    { referenceStatuteId }
  );

export const addCaseReferenceApi = (caseId, referenceCaseId) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/references`,
    { referenceCaseId }
  );

export const addStatuteReferenceApi = (caseId, referenceStatuteId) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/statute-references`,
    { referenceStatuteId }
  );

// ── Case Tasks ────────────────────────────────────────────────────────────────

export const getCaseTasksApi = (caseId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/tasks`);

export const getCaseTaskByIdApi = (caseId, taskId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/tasks/${taskId}`);

export const createCaseTaskApi = (caseId, taskData) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/tasks`,
    taskData,
    { headers: { "Content-Type": "application/json" } }
  );

export const updateCaseTaskApi = (caseId, taskId, taskData) =>
  apiClient.put(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/tasks/${taskId}`,
    taskData
  );

export const deleteCaseTaskApi = (caseId, taskId) =>
  apiClient.delete(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/tasks/${taskId}`
  );

// ── Invitations ───────────────────────────────────────────────────────────────

export const sendInvitationApi = (senderId, email, type) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_INVITATIONS}`, {
    senderId,
    email,
    type,
  });

export const sendInvitationExistingUserApi = (payload) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_INVITATIONS_EXISTING_USER}`,
    payload,
    { headers: { "Content-Type": "application/json" } }
  );

export const checkInvitationStatusApi = (ownerId, email) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CHECK_INVITATION}/${ownerId}/${email}`
  );

export const getInvitationStatsApi = (ownerId) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CHECK_INVITATION}/${ownerId}`
  );

// ── Documents ─────────────────────────────────────────────────────────────────

export const getCaseDocumentsApi = (caseId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/documents`);

export const uploadDocumentApi = (caseId, formData) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/documents`,
    formData,
    MULTIPART_CONFIG
  );

export const updateDocumentApi = (caseId, documentId, formData) =>
  apiClient.put(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/documents/${documentId}`,
    formData,
    MULTIPART_CONFIG
  );

export const deleteDocumentApi = (caseId, documentId) =>
  apiClient.delete(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/documents/${documentId}`
  );

export const downloadFileApi = (fileUrl) =>
  apiClient.get(fileUrl, null, { responseType: "blob" });

export const getFileAsBlobApi = (fileUrl, signal) =>
  apiClient.get(fileUrl, null, { responseType: "blob", signal });

// ── Comments ──────────────────────────────────────────────────────────────────

export const addCommentApi = (caseId, documentId, commentData) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_CASES}/${caseId}/documents/${documentId}/comments`,
    commentData
  );

// ── Tasks ─────────────────────────────────────────────────────────────────────

export const getAdvocateTasksApi = (userId) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_USERS}/${userId}/advocate-tasks`
  );

export const getTasksCreatedByUserApi = (userId) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_USERS}/${userId}/tasks-createdBy-user`
  );

// ── Users ─────────────────────────────────────────────────────────────────────

export const searchUsersApi = (query) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.CASE_MANAGEMENT_USERS_SEARCH}?query=${query}`);

export const getUsersEmailsApi = () =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.USERS_EMAILS}`);

// ── Token Verification ────────────────────────────────────────────────────────

export const verifyInvitationTokenApi = (token) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.VERIFY_TOKEN}?token=${token}`);
